<template>
    <div>
        <SettingsCardTitle>
            {{ __('actions.edit_thing', {thing: __('navigation.invoice_settings')}) }}
            <template v-slot:subtitle>
                {{ __('sale.invoice_settings_page_description') }}
            </template>
        </SettingsCardTitle>

        <form class="d-flex flex-column gap-lg-10 gap-5">
            <!-- COMPANY ADDRESS -->
            <StoreInvoiceCompanyAddress v-model="settings"/>

            <!-- CONTACT SETTINGS -->
            <StoreInvoiceContactSettings v-model="settings"/>

            <!-- BANK CONNECTION -->
            <StoreInvoiceBankingSettings v-model="settings"/>

            <!-- ACTIONS -->
            <SaveAndEnableButton :for="settings" @click="submitForm"/>
        </form>
    </div>
</template>

<script>
import Navigation from './Nav/Navigation.vue'
import Alert from "@components/Alert.vue";
import FormGroup from "@components/Form/FormGroup.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import StoreInvoiceSettingsGermany from "@components/Store/Edit/StoreInvoiceSettingsGermany.vue";
import StoreInvoiceSettingsAustria from "@components/Store/Edit/StoreInvoiceSettingsAustria.vue";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";
import StoreInvoiceCompanyAddress from "@components/Store/Edit/StoreInvoiceCompanyAddress.vue";
import StoreInvoiceContactSettings from "@components/Store/Edit/StoreInvoiceContactSettings.vue";
import StoreInvoiceBankingSettings from "@components/Store/Edit/StoreInvoiceBankingSettings.vue";
import SettingsCardTitle from "@components/Form/SettingsCardTitle.vue";

export default {
    layout: Navigation,

    components: {
        SettingsCardTitle,
        StoreInvoiceBankingSettings,
        StoreInvoiceContactSettings,
        StoreInvoiceCompanyAddress,
        SaveAndEnableButton,
        StoreInvoiceSettingsAustria,
        StoreInvoiceSettingsGermany,
        FormGroupNew,
        FormGroup,
        Alert
    },

    props: {
        store: Object,
        existingInvoiceSettings: Object
    },

    data() {
        return {
            settings: this.$inertia.form(this.existingInvoiceSettings),
        }
    },

    methods: {
        submitForm() {
            this.settings.post(this.$route('update-sale-delivery-note', this.store.id))
        },
    },
}
</script>
